var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('img',{attrs:{"src":_vm.item.url,"width":"100%","alt":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }